export default __webpack_public_path__ + "static/media/AnimalsOrange_09.24f9cbfc.png";